export const formatPlanning = (
  herplanDiff?: number,
  reference?: string,
  waitFor?: string,
) => {
  if (herplanDiff === undefined) {
    return ''
  }

  const diff = Math.abs(herplanDiff)
  const week = diff === 1 ? 'week' : 'weken'
  const dateComparison = herplanDiff < 0 ? 'voor' : 'na'

  if (reference === 'aanvraagDatum') {
    return `${diff} ${week} ${dateComparison} aanvraagdatum`
  }

  if (
    reference === 'geplandeUitvoeringsdatum' ||
    reference === 'startUitvoeringWeek'
  ) {
    return `${diff} ${week} ${dateComparison} geplande uitvoering`
  }

  if (reference === 'dueWeek' && waitFor) {
    return `${diff} ${week} ${dateComparison} oplevering van ${waitFor}`
  }

  if (reference === 'creatieDatum') {
    return `${diff} ${week} ${dateComparison} creatiedatum`
  }

  return ''
}
